var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommenticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59098 15.304C2.34298 9.787 6.40198 3.75 12.359 3.75H12.68C14.8196 3.75053 16.8714 4.60072 18.3843 6.11365C19.8973 7.62658 20.7474 9.6784 20.748 11.818C20.7482 12.9976 20.5161 14.1657 20.0648 15.2556C19.6135 16.3454 18.9519 17.3357 18.1178 18.1698C17.2837 19.0039 16.2934 19.6655 15.2036 20.1168C14.1137 20.5681 12.9456 20.8003 11.766 20.8H3.94598C3.7906 20.8001 3.63901 20.752 3.51216 20.6623C3.38532 20.5725 3.28947 20.4456 3.23787 20.2991C3.18628 20.1525 3.18147 19.9935 3.22412 19.8441C3.26678 19.6947 3.35478 19.5622 3.47598 19.465L5.44698 17.882C5.48912 17.8482 5.5192 17.8018 5.53272 17.7495C5.54624 17.6972 5.54247 17.642 5.52198 17.592L4.59098 15.304ZM12.359 5.25C7.46598 5.25 4.13298 10.207 5.97898 14.738L6.91098 17.027C7.05298 17.3759 7.07859 17.7614 6.984 18.126C6.88942 18.4907 6.67968 18.8151 6.38598 19.051L6.07698 19.3H11.766C12.7486 19.3003 13.7217 19.1069 14.6295 18.731C15.5374 18.3551 16.3623 17.804 17.0571 17.1092C17.752 16.4143 18.3031 15.5894 18.679 14.6815C19.0549 13.7737 19.2482 12.8006 19.248 11.818C19.2474 10.0762 18.5553 8.40593 17.3237 7.17431C16.092 5.94268 14.4218 5.25053 12.68 5.25H12.359Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommenticon);
export default __webpack_public_path__ + "static/media/comment icon.db4a6b9f92555648bcef8c395173b05c.svg";
export { ForwardRef as ReactComponent };